// src/utils/analytics.js
import ReactGA from "react-ga4";

// Khởi tạo Google Analytics
export const initGA = () => {
    //  ReactGA.initialize("G-2RDZ735QY7");
    ReactGA.initialize("G-0GK2E5FF3F");
};

// Gửi sự kiện page view
export const logPageView = () => {
    ReactGA.send({ hitType: "pageview", page: window.location.pathname });
};
